import bpModule from './bpModule';
import bpAutoComplete from './bpAutoComplete';

export default { businessProcess: bpModule, bpAutoComplete };
